export default Object.freeze({
  idle        : 'idle',
  pencil      : 'pencil',
  pen         : 'pen',
  highlighter : 'highlighter',
  eraser      : 'eraser',
  pointer     : 'pointer',
  text        : 'text',
  selector    : 'selector',
  image       : 'image',
  clear       : 'clear',
  export      : 'export',
});
